import React, { Component } from 'react';

import './MortarColor.css';
class MortarColor extends Component {
  colorClickEvent = (color) => {
    this.props.onColorClick(color);
  }
  render() {
    return (
      <div className={'mortarcolor'} >
        <div className="mortar-light" onClick={() => this.colorClickEvent("light")}>Light</div>
        <div className="mortar-medium" onClick={() => this.colorClickEvent("medium")}>Medium</div>
        <div className="mortar-dark" onClick={() => this.colorClickEvent("dark")}>Dark</div>
      </div>
    );
  }
}

export default MortarColor;
